import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import "./sidebar.css";
import IRouter from "./interface";
import { faSignOutAlt, faLayerGroup } from "@fortawesome/free-solid-svg-icons";

interface ISideBar {
  menuData: IRouter[];
  panelName: string;
  baseUrl: string;
  collapsed?: boolean;
}

export default function SideBar({ menuData, baseUrl, collapsed }: ISideBar) {
  let navigate = useNavigate();

  const showAllowedMenu = menuData.filter(
    (routes) => routes.navbarShow === true
  );

  return (
    <aside className={`ds-sidebar ${collapsed ? "ds-sidebar--collapsed" : ""}`}>
      <div className="ds-sidebar-brand">
        <span className="ds-sidebar-logo">
          <FontAwesomeIcon icon={faLayerGroup} />
        </span>
        <span className="ds-sidebar-brand-text">EXMBNK</span>
      </div>

      <nav className="ds-sidebar-nav">
        {showAllowedMenu.map((data, index) => {
          const isActive = window.location.href.split("/")[4] === data.path;
          return (
            <button
              key={index}
              type="button"
              title={data.name}
              className={`ds-nav-item ${isActive ? "ds-nav-item--active" : ""}`}
              onClick={() => navigate(baseUrl + "/" + data.path)}
            >
              <span className="ds-nav-indicator" />
              <span className="ds-nav-icon">
                <FontAwesomeIcon icon={data.icon} />
              </span>
              <span className="ds-nav-label">{data.name}</span>
            </button>
          );
        })}
      </nav>

      <div className="ds-sidebar-foot">
        <button
          type="button"
          title="Logout"
          className="ds-nav-item ds-nav-item--logout"
          onClick={() => {
            sessionStorage.clear();
            window.location.reload();
          }}
        >
          <span className="ds-nav-icon">
            <FontAwesomeIcon icon={faSignOutAlt} />
          </span>
          <span className="ds-nav-label">Logout</span>
        </button>
      </div>
    </aside>
  );
}
